import Tabs from '@/components/Tabs'
import { useAppSelector, useUrlSearchParam } from '@/hooks'
import { useHistory } from 'react-router-dom'
import { track } from '@/logging/mixpanel'
import ProgramTab from './ProgramTab'
import PageLoader from '@/authenticated/components/layout/PageLoader'
import { energySystemCollection } from '@/reducers/energySystems'
import { EnergySystem } from '@/types/energySystem'
import SettingsTab from './SettingsTab'

function EnergySystemDevicesContent(props: { energySystem: EnergySystem }) {
  const { energySystem } = props
  const initialTab = useUrlSearchParam('tab')
  const tabs = ['Programs', 'Settings']
  const history = useHistory()

  const handleTabChange = (index: number) => {
    const tab = tabs[index]
    history.replace({ search: `?tab=${tab.toLowerCase()}` })
    track('Energy System Tab Clicked', { tab_name: tab })
  }

  return (
    <div className="flex flex-col items-center space-y-6">
      <Tabs.Tabs
        initialTabIndex={+(initialTab === 'settings')}
        tabKey="devices-energy-system-tabs"
        labels={tabs}
        tabBarAttributes={{ className: 'max-w-none' }}
        onTabChange={handleTabChange}
      />
      <Tabs.Content tabKey="devices-energy-system-tabs">
        <ProgramTab energySystem={energySystem} />
        <SettingsTab energySystem={energySystem} />
      </Tabs.Content>
    </div>
  )
}

export default function EnergySystemDevicesPage(props: {
  energySystemId: string
}) {
  const userPresent = useAppSelector((state) => Boolean(state.user.user))

  const { data: allEnergySystems, isLoadingOrIdle: loadingEnergySystems } =
    energySystemCollection.useFetch('energy-systems')

  const energySystem = allEnergySystems?.find(
    (energySystem) => energySystem.id === props.energySystemId,
  )

  const loading = !userPresent || loadingEnergySystems

  if (loading) {
    return (
      <div style={{ width: '100%', height: '400px' }}>
        <PageLoader />
      </div>
    )
  }

  if (!energySystem) {
    return null
  }

  return <EnergySystemDevicesContent energySystem={energySystem} />
}
